<!-- ----------------------------------------------- -->
<template>
  <v-card id="info-dialog" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header pa-0">
      <span class="com-mb-dialog-title">お知らせ情報詳細</span>
      <v-spacer></v-spacer>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents pa-0">
      <if-detail></if-detail>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 お知らせ検索
 * Info.vue
 * @author LIS
 */

import mixin from "./../../../lib/mixin.js";
/** お知らせ情報詳細カード */
import IfDetail from "../../../components/mb/IfDetail.vue";

export default {
  name: "mb-info-detail",
  mixins: [mixin],
  components: {
    IfDetail
  },
  data() {
    return {};
  },
  beforeMount() {
    // URLパラメータ取得
    var urlParam = this.$route.query["infmgcd"];
    this.getInformationInfo(urlParam);
  },

  mounted() {
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "info");
  },
  computed: {
    /**
     * お知らせ詳細
     */
    informationInfo: {
      get() {
        return this.$store.state.info.informationInfo.info;
      }
    }
  },
  methods: {
    /**
     * お知らせ詳細取得
     */
    getInformationInfo(urlParam) {
      setTimeout(() => {
        this.$store.dispatch("info/getInformationInfo", urlParam);
      }, 500);
    },
    closeDlg() {
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}
#info-dialog {
  right: 4px;
  overflow: hidden;
}
</style>
